import React, { useContext, useState } from 'react';
import { Breadcrumb, BreadcrumbItem, Col, Nav, NavItem, NavLink } from 'reactstrap';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import ProfileDropdown from './ProfileDropdown';
import AppContext from '../../context/Context';
import { VendorsContext } from '../../context/VendorsContext';

const TopNavRightSideNavItem = () => {
  const { isTopNav, isCombo } = useContext(AppContext);
  const [vendors, setVendors] = useContext(VendorsContext);
  const [vendorLabel, setVendorLabel] = useState('');
  console.log('vendorscontext', vendors);
  const { slug } = useParams();
  const { pathname } = useLocation();
  let navigate = useNavigate();
  const pathnames = pathname.split('/').filter(Boolean);
  console.log('pathnames', pathnames);

  // Use vendor label from context if available
  if (pathnames.length && pathnames[0] === 'vendors' && pathnames.length > 1) {
    const vendorLabel = vendors.find(vendor => vendor.id === pathnames[1])?.name;
    if (vendorLabel) pathnames[1] = vendorLabel;
  }
  // If integrations, remove any element after 0th index
  if (pathnames.length && pathnames[0] === 'integrations') {
    pathnames.splice(1);
  }
  // If path is a number. Remove it from breadcrumbs
  for (let i = 0; i < pathnames.length; i++) {
    if (!isNaN(pathnames[i]) && !isNaN(parseInt(pathnames[i]))) {
      pathnames.splice(i, 1);
      i--; // Adjust index after removal
    }
  }

  // const mapObj = {
  //   bugzero: 'BugZero',
  //   BugZero: 'BugZero',
  //   servicenow: 'ServiceNow',
  //   ServiceNow: 'ServiceNow',
  //   aws: 'AWS',
  //   db: 'DB',
  //   api: 'API',
  //   app: 'App',
  //   App: 'App',
  //   cmdb: 'CMDB',
  //   CMDB: 'CMDB',
  //   sso: 'SSO',
  //   SSO: 'SSO',
  //   rh: 'Red Hat'
  // };

  // const re = new RegExp(Object.keys(mapObj).join('|'), 'gi');
  if (!vendors.length) return null;
  return (
    <Nav navbar className="navbar-nav-icons ml-auto flex-row align-items-center">
      {/* <NotificationDropdown /> */}
      {pathname.length > 1 && (
        <>
          <NavLink onClick={() => navigate(-1)}>Back</NavLink>
          <NavItem className="ml-3">|</NavItem>
        </>
      )}

      <Col md="auto" className="mt-4 mt-md-0 mr-4">
        <Breadcrumb>
          {pathnames.map((name, index) => {
            // const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;
            return isLast ? (
              <BreadcrumbItem key={name + 'key'} className="text-capitalize ml-1" active={true}>
                {decodeURIComponent(name.replace(/-/g, ' ').replace('sso sn', ''))
                // .replace('postgre', 'PostgreSQL')
                }
              </BreadcrumbItem>
            ) : (
              // <Link to={routeTo} key={name + 'key'}>
              <BreadcrumbItem key={name} className="text-capitalize ml-1">
                {decodeURIComponent(name.replace(/-/g, ' ').replace('sso sn', ''))
                // .replace('postgre', 'PostgreSQL')
                }
              </BreadcrumbItem>
              // </Link>
            );
          })}
        </Breadcrumb>
      </Col>
      <ProfileDropdown />
    </Nav>
  );
};

export default TopNavRightSideNavItem;
